<!--
// app/components/pages/region-home/TablesBracketHome.vue
-->
<script setup lang="ts">
import { useRegions } from "~/app/composables/regions";
import BracketTablesNations from "~/app/components/pages/region-nations/BracketTablesNations.vue";
import BracketTablesWorldCup from "~/app/components/pages/region-world-cup/BracketTablesWorldCup.vue";

const localePath = useLocalePath();
const { regionParam, isNations, isWorldCup } = useRegions();
</script>

<template>
  <div class="bg-gray-900 p-2.5 sm:p-4 rounded-lg">
    <div>
      <div class="justify-between flex text-gray-400 uppercase text-sm mb-2 items-end">
        <div class="flex flex-row gap-2">
          <p v-if="!isNations && !isWorldCup">
            <span class="sm:hidden">KWCC</span
            ><span class="hidden sm:inline-block">Kings World Cup Clubs</span> Paris 2025
          </p>
          <p v-else>{{ $t("tables.banner.title") }}</p>
        </div>

        <nuxt-link
          :to="
            !isNations && !isWorldCup
              ? localePath({ name: 'region', params: { region: 'world-cup' } })
              : localePath({
                  name: `region-Tables`,
                  params: { region: regionParam },
                })
          "
          :external="!isNations && !isWorldCup"
          class="normal-case text-primary text-xs"
        >
          {{ $t("cards.stats.seeMore.link") }}
        </nuxt-link>
      </div>
      <hr />
      <bracket-tables-nations v-if="isNations" is-home-component></bracket-tables-nations>

      <bracket-tables-world-cup
        v-else
        is-home-component
        :in-other-leagues-home="!isWorldCup"
        :season-id-data="37"
      ></bracket-tables-world-cup>
    </div>
  </div>
</template>

<style scoped></style>
